import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSlice } from '@reduxjs/toolkit';
import { POPULATE_STORE } from '@beef/redux';
import { DEFAULT_PAYMENT_PARAMS, PAYMENT_METHODS_OPTIONS } from "../../constants/payment";
var initialState = {
  userInfo: {},
  popupContent: {},
  paymentParams: DEFAULT_PAYMENT_PARAMS,
  paymentMethods: [],
  activeTab: null,
  currentPaymentMethod: null,
  inlineLayout: true,
  paymentData: {},
  spfCaption: PAYMENT_METHODS_OPTIONS.fps.title,
  bankList: [],
  isRedesign: false
};
export var commonSlice = createSlice({
  name: 'common',
  initialState: initialState,
  reducers: {
    setActiveTab: function setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    setCurrentPaymentMethod: function setCurrentPaymentMethod(state, action) {
      state.currentPaymentMethod = action.payload;
    },
    setSpfCaption: function setSpfCaption(state, action) {
      state.spfCaption = action.payload;
    },
    setPaymentData: function setPaymentData(state, action) {
      state.paymentData = _objectSpread(_objectSpread({}, state.paymentData), action.payload);
    },
    setPaymentMethods: function setPaymentMethods(state, action) {
      state.paymentMethods = action.payload;
    },
    setPaymentParams: function setPaymentParams(state, action) {
      state.paymentParams = action.payload;
    },
    setBankList: function setBankList(state, _ref) {
      var payload = _ref.payload;
      state.bankList = payload;
    },
    setUserInfo: function setUserInfo(state, _ref2) {
      var payload = _ref2.payload;
      state.userInfo = payload;
    },
    setIsAuth: function setIsAuth(state, _ref3) {
      var payload = _ref3.payload;
      state.isAuth = !!payload;
    },
    setIsRedesign: function setIsRedesign(state, _ref4) {
      var payload = _ref4.payload;
      state.isRedesign = payload;
    }
  },
  extraReducers: _defineProperty({}, POPULATE_STORE, function (_, action) {
    return _objectSpread(_objectSpread({}, initialState), action.payload);
  })
});
export var commonActions = commonSlice.actions;